import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BeatLoader from 'react-spinners/BeatLoader';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import CustomPagination from '../../common/CustomPagination';
import VideoModal from './VideoModal';
import Layout from './Layout';
import {
  BUILDER_FREE,
  prepareProjectMessage,
  prepareProjectStats,
  UNLIMITED,
} from '../common/constants';
import ProjectDetailOld from './project/ProjectDetailOld';
import HTMLReactParser from 'html-react-parser';
import {
  consumePendingPrompt,
  generateMeaningfulProjectName,
} from '../../common/utils/prompt-storage';

export class Dashboard extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    currentPage: 1,
    perPage: 12,
    showVideoModal: false,
    isAutoCreatingAIProject: false,
  };

  componentDidMount() {
    document.title = 'Dashboard - Drapcode';
    const { actions } = this.props;
    const { currentPage, perPage } = this.state;
    actions.getAllProjects({ page: currentPage - 1, size: perPage });

    this.handlePendingPromptCreation();
  }

  handlePendingPromptCreation = async () => {
    const pendingPrompt = consumePendingPrompt();
    if (!pendingPrompt || (!pendingPrompt.prompt && pendingPrompt.keys.length === 0)) {
      return;
    }

    const {
      login: { token },
      actions,
      protocol,
      configurationSurface,
    } = this.props;
    this.setState({ isAutoCreatingAIProject: true });

    const { prompt, keys } = pendingPrompt;

    try {
      // TODO: Remove this static project name and use the generateMeaningfulProjectName function
      // const projectName = `AI project`
      const projectName = generateMeaningfulProjectName(prompt);

      const formData = new FormData();
      formData.append('name', projectName);
      formData.append('description', prompt || 'AI project created with attachments');
      formData.append('framework', 'BOOTSTRAP');

      const apiData = await actions.createClientProject({ formData });

      console.log('apiData>>>', apiData);

      if (apiData && apiData.uuid && apiData.seoName) {
        const queryParams = new URLSearchParams();
        queryParams.set('token', token);

        if (prompt) {
          queryParams.set('prompt', prompt);
        }

        if (keys.length > 0) {
          queryParams.set('keys', keys.join(','));
        }

        // 5. Construct the AI Prompt Builder target URL
        const redirectUrl = `${protocol}://${
          apiData.seoName
        }.${configurationSurface}2.0/vibe-coding/1/v/${apiData.uuid}/?${queryParams.toString()}`;
        // Smooth redirect into the AI builder
        window.location.href = redirectUrl;
      } else {
        this.setState({ isAutoCreatingAIProject: false });
      }
    } catch (error) {
      console.error('Failed to auto-create project from prompt:', error);
      this.setState({ isAutoCreatingAIProject: false });
    }
  };

  handlePageChange = (page) => {
    const { actions, home } = this.props;
    const { perPage } = this.state;
    const { projectMetadata } = home;
    const newPage = Math.max(1, Math.min(page, Math.ceil(projectMetadata.totalProjects / perPage)));
    this.setState({ currentPage: newPage }, () => {
      actions.getAllProjects({ page: newPage - 1, size: perPage });
    });
  };

  openVideoModal = () => {
    this.setState({ showVideoModal: true });
  };

  closeVideoModal = () => {
    this.setState({ showVideoModal: false });
  };

  renderProjects() {
    const { login, home, protocol, builderSurface, exchange_surface, configurationSurface } =
      this.props;
    const token = login.token;
    const { projectMetadata } = home;
    const { content } = projectMetadata.filteredProjects || {};
    if (!content) {
      return null;
    }
    return (
      <>
        {content.map((project, index) => (
          <div className="col-lg-4 col-md-6 mb-4 d-flex" key={index}>
            <ProjectDetailOld
              index={`p${index}`}
              project={project}
              protocol={protocol}
              builderSurface={builderSurface}
              exchange_surface={exchange_surface}
              configurationSurface={configurationSurface}
              token={token}
            />
          </div>
        ))}
      </>
    );
  }
  calculateProjectStepPer = (project) => {
    if (!project) {
      return 0;
    }
    const { steps } = project;
    if (!steps || steps.length === 0) {
      return 0;
    }
    const perComplete = steps.map((step) => step.value).reduce((acc, step) => acc + step);
    return perComplete;
  };

  renderCreateProjectLink = () => {
    const { home } = this.props;
    const { orgClient, projectStats } = home;
    const { projectCountAllowed, projects, subscription, maxFreeProjects, maxPaidProjects } =
      orgClient;
    if (subscription === 'BUILDER_FREE') {
      return (
        <>
          {/* <h6 className="align-center">To start your journey, you have to upgrade your account.</h6> */}
          <Link to="/accounts" className="btn btn-success btn-md text-white">
            Upgrade your account
          </Link>
        </>
      );
    } else if (subscription === 'UNLIMITED') {
      return (
        <Link className="btn btn-success text-white btn-md" to={'/create-project-select'}>
          <i className="fa fa-plus me-sm-1"></i>
          Create Project
        </Link>
      );
    } else {
      if (!projects || projects.length <= 0) {
        return (
          <Link className="btn btn-success text-white btn-md" to={'/create-project-select'}>
            <i className="fa fa-plus me-sm-1"></i>
            Create Project
          </Link>
        );
      }

      const stats = prepareProjectStats(orgClient, projectStats);
      console.log('stats :>> ', stats);
      if (!stats.success) {
        // return <p>{stats.message}</p>;
        // return (
        //   <span className="alert alert-warning rounded text-white d-flex align-items-center mb-0">
        //     <i className="material-icons">warning</i>&nbsp;
        //     <span>{HTMLReactParser(stats.message)}</span>
        //   </span>
        // );
        return (
          <Link className="btn btn-success text-white btn-md disabled" disabled to={'#'}>
            <i className="fa fa-plus me-sm-1"></i>
            Create Project
          </Link>
        );
      }
      return (
        <Link className="btn btn-success text-white btn-md" to={'/create-project-select'}>
          <i className="fa fa-plus me-sm-1"></i>
          Create Project
        </Link>
      );
    }
  };

  renderProjectStatsMessage = () => {
    const { home } = this.props;
    const { orgClient, projectStats } = home;
    const { projects, subscription } = orgClient;
    if (!subscription || ![BUILDER_FREE, UNLIMITED].includes(subscription)) {
      if (projects && projects.length >= 1) {
        const stats = prepareProjectStats(orgClient, projectStats);
        if (!stats.success) {
          return (
            <span className="alert alert-warning rounded text-white d-flex align-items-center mb-0 w-100">
              <i className="material-icons">warning</i>&nbsp;
              <span>{HTMLReactParser(stats.message)}</span>
            </span>
          );
        }
      }
    }
  };

  zeroProjectUI = () => {
    const { home } = this.props;
    const { projectMetadata, getAllProjectsPending } = home;
    console.log('zeroProjectUI :>> ');
    if (getAllProjectsPending) {
      console.log('1');
      return (
        <div className="row mt-4">
          <div className="col-lg-12 d-flex align-items-center justify-content-center">
            <div className="tm-section-title custom-h1-tm-section-title text-center mt-5">
              <BeatLoader
                css={{ display: 'inline-block' }}
                size="15px"
                margin="5px"
                color="#344767"
                loading={getAllProjectsPending}
              />
            </div>
          </div>
        </div>
      );
    } else {
      console.log('2');
      const { totalProjects } = projectMetadata ? projectMetadata : { totalProjects: 0 };
      if (totalProjects !== 0) {
        console.log('3');
        console.log(`I have ${totalProjects} project/s so return`);
        return '';
      }
      console.log('4');
      return (
        <div className="row mt-4">
          <div className="col-lg-12 d-flex align-items-center justify-content-center">
            <div className="tm-section-title custom-h1-tm-section-title text-center mt-5">
              <h3>Welcome!</h3>
              <p className="text-dark" style={{ fontSize: 'large' }}>
                We are excited to commence your DrapCode journey! Get ready
                <br /> to give your cool ideas a concrete shape by building amazing
                <br /> web apps.
              </p>
              {/* don't remove this comment */}
              {/* <button className="btn btn-primary p-2" onClick={this.openVideoModal}>
              <img
                src="https://app.drapcode.com/public/maxresdefault%20(1).jpg"
                style={{ width: '480px' }}
                alt="Short Intro Video"
              />
            </button> */}
              <div className="mb-0 me-3 mt-5">{this.renderCreateProjectLink()}</div>
            </div>
          </div>
          {/* don't remove this cmt */}
          {/* <ResourceLinks protocol={protocol} projectDomain={project_domain} /> */}
          {/* <SocialMediaLinks />{' '} */}
        </div>
      );
    }
  };

  nonZeroProjectUI = () => {
    const { home } = this.props;
    const { projectMetadata, orgClient, projectStats } = home;
    console.log('🚀 ~ file: Dashboard.js:242 ~ Dashboard ~ projectStats:', projectStats);
    const { totalProjects, filteredProjects } = projectMetadata
      ? projectMetadata
      : { totalProjects: 0 };
    console.log('5');
    if (totalProjects === 0) {
      console.log('6');
      console.log(`I have zero project so return`);
      return '';
    }
    const { totalPages } = filteredProjects ? filteredProjects : 0;
    const { currentPage, perPage, showVideoModal } = this.state;
    const { subscription } = orgClient || '';
    const message = prepareProjectMessage(orgClient, projectStats);
    return (
      <>
        {/* <div className="d-flex justify-content-between mb-0 me-3 mt-5 align-items-center">
          <span className="alert alert-info rounded text-white d-flex align-items-center">
            <i className="material-icons">info</i>&nbsp;{HTMLReactParser(message)}
          </span>
          {this.renderCreateProjectLink()}
        </div> */}

        <div className="d-flex justify-content-end mb-0 me-3 mt-5 align-items-center">
          {this.renderCreateProjectLink()}
        </div>
        <div className="d-flex mb-0 me-3 align-items-center gap-2 flex-column">
          {message && (
            <span className="alert alert-info rounded text-white d-flex align-items-center mb-0 w-100">
              <i className="material-icons">info</i>&nbsp;<span>{HTMLReactParser(message)}</span>
            </span>
          )}
          {!message && subscription === 'BUILDER_FREE' && (
            <span className="alert alert-warning rounded text-white d-flex align-items-center mb-0 w-100">
              <i className="material-icons">warning</i>&nbsp;
              <span>{HTMLReactParser(`To start your journey, please upgrade your account.`)}</span>
            </span>
          )}
          {this.renderProjectStatsMessage()}
        </div>
        <div className="row mt-4">{this.renderProjects()}</div>
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePageChange={this.handlePageChange}
        />
        <VideoModal isOpen={showVideoModal} toggle={this.closeVideoModal} />
      </>
    );
  };

  render() {
    console.log('Dashboard Render');
    const { home } = this.props;
    const { clientDetail } = home;

    // Show AI workspace generation loader if processing
    if (this.state.isAutoCreatingAIProject) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center min-vh-100"
          style={{ backgroundColor: '#f8f9fa' }}
        >
          <BeatLoader size={20} color="#344767" loading={true} />
          <h4 className="mt-4 font-weight-bolder text-dark">Setting up your AI Project...</h4>
          <p className="text-muted">Generating your workspace canvas based on your prompt.</p>
        </div>
      );
    }

    if (!clientDetail) {
      return;
    }

    const { status } = clientDetail;
    console.log('status :>> ', status);
    if (status === 'AWAITING_APPROVAL') {
      return (
        <div className="row mt-4">
          <div className="col-lg-12 d-flex align-items-center justify-content-center">
            <div className="tm-section-title custom-h1-tm-section-title text-center mt-5">
              <h3>Welcome!</h3>
              <p className="text-dark" style={{ fontSize: 'large' }}>
                Your account is not approved. Please contact Admin.
              </p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <Layout currentPage="Dashboard">
        {this.zeroProjectUI()}
        {this.nonZeroProjectUI()}
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    login: state.login,
    protocol: process.env.REACT_APP_HTTPS === 'true' ? 'https' : 'http',
    builderSurface: process.env.REACT_APP_BUILDER_SURFACE,
    configurationSurface: process.env.REACT_APP_CONFIGURATION_SURFACE,
    exchange_surface: process.env.REACT_APP_EXCHANGE_SURFACE,
    project_domain: process.env.REACT_APP_PROJECT_DOMAIN,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
